import { Typography } from '@mui/material';
import type { ReactNode } from 'react';

/**
 * The uppercase micro-label used on table headers, tile captions and stat
 * labels — the design system's `Typography variant="label" uppercase`, plus the
 * one thing it does not tokenise: letter spacing.
 *
 * This existed 25 times as an inline sx block, each re-declaring the same five
 * properties, and the tracking was written three different ways for the same
 * value (`.04em` and `0.04em`, `.05em` and `0.05em`, `.06em` and `0.06em`) —
 * which is what made the duplication invisible to grep.
 */
export const MICRO_LABEL_TRACKING = '0.05em';

export type MicroLabelProps = {
  children: ReactNode;
  /** Defaults to the muted foreground; pass a token to emphasise. */
  color?: string;
  component?: 'span' | 'div' | 'p';
  'data-automation-id'?: string;
};

export const MicroLabel = ({
  children,
  color = 'var(--fg-3)',
  component = 'span',
  'data-automation-id': automationId,
}: MicroLabelProps) => (
  <Typography
    variant="label"
    uppercase
    component={component}
    data-automation-id={automationId}
    sx={{ letterSpacing: MICRO_LABEL_TRACKING, color }}
  >
    {children}
  </Typography>
);
